import { render, staticRenderFns } from "./RecentAuditCard.vue?vue&type=template&id=5a3b5a80&scoped=true&"
import script from "./RecentAuditCard.vue?vue&type=script&lang=ts&"
export * from "./RecentAuditCard.vue?vue&type=script&lang=ts&"
import style0 from "./RecentAuditCard.vue?vue&type=style&index=0&id=5a3b5a80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3b5a80",
  null
  
)

export default component.exports